import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum EPrescriptionIngredientUnitEnum {
    GRAM = 'g',
    PIECE = 'ks',
}

export const ePrescriptionIngredientUnitEnumOptions = enumToOptions(
    EPrescriptionIngredientUnitEnum,
    'ePrescriptions.ingredientUnitEnum.',
);

// Exact SÚKL tablet form codes; combined forms and unknown forms have no default.
const TABLET_FORMS: ReadonlySet<string> = new Set([
    'TBL EFF', 'TBL ENT', 'TBL FLM', 'TBL FLM SCC', 'TBL GGR', 'TBL MND', 'TBL MND PRO', 'TBL MND/SUS',
    'TBL MRL', 'TBL NOB', 'TBL OBD', 'TBL PRO', 'TBL SNS', 'TBL SOL', 'TBL SUS', 'TBL SUS DSD',
]);

export function getEPrescriptionIngredientUnitForForm(form?: string | null): EPrescriptionIngredientUnitEnum | null {
    return form && TABLET_FORMS.has(form) ? EPrescriptionIngredientUnitEnum.PIECE : null;
}
